// extracted by mini-css-extract-plugin
export default {"wrapper":"Categories_wrapper__Mwdge","content":"Categories_content__Gg2za","categories":"Categories_categories__CbK+f","links":"Categories_links__KCGqa"};